import React from 'react';
import { UitkCheckbox } from 'uitk-react-checkbox';
import gaLogger from 'src/utils/ga-logger';

interface CheckBoxProps {
  id: string;
  label: string;
  exClass?: string;
  value?: boolean;
  onChangeEvent?: (id: any, evt: any) => any;
  gaTracking:
    | {
        eventCategory: string;
        eventAction: string;
        eventLabel: string;
      }
    | undefined;
  errorMessage: string;
}

const CheckBox: React.FC<CheckBoxProps> = props => {
  const { id, label, exClass, value, onChangeEvent, gaTracking, ...rest } = props;

  const onChange = e => {
    if (onChangeEvent) {
      onChangeEvent(id, e);
    }
    if (gaTracking) {
      const { eventCategory, eventAction, eventLabel } = gaTracking;
      gaLogger.logGa(eventCategory, eventAction, eventLabel);
    }
  };

  return (
    <UitkCheckbox id={id} className={exClass} checked={value} onChange={e => onChange(e)} {...rest}>
      {label}
    </UitkCheckbox>
  );
};

export { CheckBoxProps, CheckBox };